/**
 * @generated SignedSource<<f99eb225e5eeaec4c0ce9d440778307f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ids"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "ids",
        "variableName": "ids"
      }
    ],
    "concreteType": "GenerateComparePdfMutationResponse",
    "kind": "LinkedField",
    "name": "generateComparePdf",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GenerateComparePdfMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GenerateComparePdfMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a7d1ca7b233bf0d3a503b3e7f2926c23",
    "id": null,
    "metadata": {},
    "name": "GenerateComparePdfMutation",
    "operationKind": "mutation",
    "text": "mutation GenerateComparePdfMutation(\n  $ids: [String]!\n) {\n  generateComparePdf(ids: $ids) {\n    ok\n    error\n  }\n}\n"
  }
};
})();

node.hash = "f9de547a0595050ee6d81cc59c9cc982";

export default node;
